import { render, staticRenderFns } from "./DropZoneComponent.vue?vue&type=template&id=0617395d&scoped=true"
import script from "./DropZoneComponent.vue?vue&type=script&lang=js"
export * from "./DropZoneComponent.vue?vue&type=script&lang=js"
import style0 from "./DropZoneComponent.vue?vue&type=style&index=0&id=0617395d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617395d",
  null
  
)

export default component.exports